export const LIST_EVENTS = 'event_log.LIST_EVENTS';
export const LIST_EVENTS_SUCCESS = 'event_log.LIST_EVENTS_SUCCESS';
export const LIST_EVENTS_FAILURE = 'event_log.LIST_EVENTS_FAILURE';
export const UPDATE_EVENTS_FILTER = 'event_log.UPDATE_EVENTS_FILTER';
export const OPEN_EVENT_DETAIL_DIALOG = 'event_log.OPEN_EVENT_DETAIL_DIALOG';
export const CLOSE_EVENT_DETAIL_DIALOG = 'event_log.CLOSE_EVENT_DETAIL_DIALOG';